import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

const SKIPPED_URLS = ['/assets/i18n/'];

export const loadingInterceptor: HttpInterceptorFn = (request, next) => {
  if (SKIPPED_URLS.some(url => request.url.includes(url))) {
    return next(request);
  }

  const loadingService = inject(LoadingService);
  loadingService.show();

  return next(request).pipe(finalize(() => loadingService.hide()));
};
